/**
 * Datos maestros del sitio usados por el SEO (meta tags, JSON-LD, sitemap, prerender).
 * Este archivo es .mjs porque también lo leen los scripts de Node (scripts/prerender.mjs).
 * No importar nada de React aquí.
 */
export const SITE = {
    name: 'Coralan Multiservice',
    legalName: 'Coralan Multiservice SRL',
    url: 'https://coralanmultiservice.com',
    locale: 'es_DO',
    language: 'es',
    tagline: 'Desarrollo de software, facturación electrónica y soluciones digitales en República Dominicana',
    defaultDescription:
        'Empresa de desarrollo de software en Santo Domingo, República Dominicana: software a la medida, ' +
        'desarrollo web (Drupal, WordPress, React), apps móviles, facturación electrónica DGII (e-CF), ' +
        'CRM/POS, eCommerce y marketing digital. Más de 15 años de experiencia.',
    logo: 'https://coralanmultiservice.com/assets/custom/images/coralan-multiservice-logo.png',
    ogImage: 'https://coralanmultiservice.com/assets/custom/images/og-default.jpg',
    phone: '+1-809-605-0699',
    phoneDisplay: '+1 (809) 605-0699',
    whatsapp: 'https://wa.me/18096050699',
    email: 'info@coralanmultiservice.com',
    rnc: '1-32-03635-2',
    addressDisplay: 'C/ San Juan Bautista de la Salle #17, Mirador Norte, Santo Domingo, D.N.',
    address: {
        streetAddress: 'C/ San Juan Bautista de la Salle #17, Mirador Norte',
        addressLocality: 'Santo Domingo',
        addressRegion: 'Distrito Nacional',
        addressCountry: 'DO',
    },
    // TODO: coordenadas exactas (Google Maps → clic derecho sobre el local → copiar lat,lng). Aproximación del sector Mirador Norte.
    geo: { latitude: 18.4980, longitude: -69.9420 },
    openingHours: ['Mo-Fr 08:00-18:00'],
    foundingYear: 2009,
    // TODO: agregar perfiles reales (LinkedIn, Facebook, Instagram, Google Business, Clutch, GitHub).
    // Cada URL aquí refuerza la señal "misma entidad" en Google y en modelos de IA.
    sameAs: [
        'https://www.instagram.com/coralanmultiservice',
        'https://web.facebook.com/profile.php?id=61554063135548',
        'https://share.google/viicbdyS3gSGQw8Au'
    ],
    areaServed: ['República Dominicana', 'Santo Domingo', 'Santiago', 'Latinoamérica', 'Estados Unidos'],
};

export const absoluteUrl = (path = '/') => {
    if (/^https?:\/\//i.test(path)) return path;
    const clean = path.startsWith('/') ? path : `/${path}`;
    return clean === '/' ? `${SITE.url}/` : `${SITE.url}${clean.replace(/\/$/, '')}`;
};
